import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import ColorThemeContextProvider from './app/colorThemeContext/ColorThemeContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ColorThemeContextProvider>
    <App />
  </ColorThemeContextProvider>
);


